import {ratingDao } from '@/service';

export default {
  state: {},
  mutations: {},
  actions: {   
    getAllData  (_, payload) {
      return new Promise((resolve, reject) => {
        ratingDao
          .getAllData(payload)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveAvaliation(_, payload) {
      return new Promise((resolve, reject) => {
        ratingDao
          .saveAvaliation(payload)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  getters: {},
};
